import { render, staticRenderFns } from "./QuizChoices.vue?vue&type=template&id=34db4bc6&"
import script from "./QuizChoices.vue?vue&type=script&lang=js&"
export * from "./QuizChoices.vue?vue&type=script&lang=js&"
import style0 from "./QuizChoices.vue?vue&type=style&index=0&id=34db4bc6&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports